module.exports = __webpack_public_path__ + "img/chanpin1.5e779428.png";